import React, { useState, useEffect } from "react";
import "./NouveauClientUnitaire.css";
import FormHeader from "../../../Utils/Commons/Forms/FormHeader/FormHeader";
import { useAuth } from "../../../Security/AuthProvider";
import { useNotification } from "../../../Utils/Commons/Notification/NotificationContext";

const NouveauClientUnitaire = ({ setShowNewClients }) => {
  const { getCredentials } = useAuth();
  const { notifyError, notifySuccess } = useNotification();
  const [operations, setOperations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchOperations();
  }, []);

  const fetchOperations = async () => {
    try {
      const credentials = getCredentials();
      const response = await fetch("/operations/get-all", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          company_name: credentials.company_name,
          company_password: credentials.company_password,
        }),
      });
      const data = await response.json();
      setOperations(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Erreur lors de la récupération des opérations:", error);
      setOperations([]);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    
    try {
      const formData = new FormData(event.target);
      const { company_name, company_password } = getCredentials();
      
      // Convertir FormData en objet JSON
      const data = {};
      for (let [key, value] of formData.entries()) {
        data[key] = value;
      }
      
      // Ajouter les credentials
      data.company_name = company_name;
      data.company_password = company_password;
      
      console.log("Données à envoyer:", data);
      
      const response = await fetch("/client/new-client", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Ajout échoué");
      }
      
      notifySuccess("Client ajouté avec succès");
      event.target.reset();
    } catch (error) {
      notifyError(`Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="popup-container" onClick={() => setShowNewClients(false)}>
      <div
        className="nouveau-client-unitaire-container general-data-form-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="form-content">
          <FormHeader title="Ajouter un client" />
          <form onSubmit={handleSubmit} className="nouveau-client-form">
            <div className="form-group">
              <label htmlFor="name">Nom</label>
              <input type="text" id="name" name="name" required />
            </div>
            <div className="form-group">
              <label htmlFor="prenom">Prénom</label>
              <input type="text" id="prenom" name="prenom" />
            </div>
            <div className="form-group">
              <label htmlFor="adresse">Adresse</label>
              <input type="text" id="adresse" name="adresse" required />
            </div>
            <div className="form-group">
              <label htmlFor="code_postal">Code Postal</label>
              <input 
                type="text" 
                id="code_postal" 
                name="code_postal" 
                required 
                pattern="[0-9]{5}"
                title="Le code postal doit contenir 5 chiffres"
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" />
            </div>
            <div className="form-group">
              <label htmlFor="telephone">Téléphone</label>
              <input type="tel" id="telephone" name="telephone" required />
            </div>
            <div className="form-group">
              <label htmlFor="operation_name">Opération</label>
              <select id="operation_name" name="operation_name" required>
                <option value="">Sélectionnez une opération</option>
                {Array.isArray(operations) && operations.map((operation) => (
                  <option key={operation.id} value={operation.name}>
                    {operation.name}
                  </option>
                ))}
              </select>
            </div>
            <button type="submit" disabled={loading} className="new-data-button">
              {loading ? "Chargement..." : "Envoyer"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NouveauClientUnitaire;
